import React, { useMemo, useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { COLORS, PRICE, ROUND_PRICE } from "./animauxTagsData";

const CAT_PRICE = 8.99;

const labels = {
  fr: {
    catsTab: "Chats",
    catsTitle: "Médailles pour chats",
    catsText: "Collection spéciale pour chats • 25 mm • légère et brillante.",
    size: "25 mm",
    priceSuffix: "CAD",
    select: "Choisir cette médaille",
    catNames: {
      turquoise: "Turquoise Premium",
      rouge: "Rouge Luxe",
      violet: "Violet Élégant",
      violetKey: "Violet porte-clés",
      orange: "Orange Énergie",
      bleu: "Bleu Royal",
    },
  },
  en: {
    catsTab: "Cats",
    catsTitle: "Cat tags",
    catsText: "Special cat collection • 25 mm • lightweight and shiny.",
    size: "25 mm",
    priceSuffix: "CAD",
    select: "Choose this tag",
    catNames: {
      turquoise: "Premium Turquoise",
      rouge: "Luxury Red",
      violet: "Elegant Purple",
      violetKey: "Purple keyring",
      orange: "Energy Orange",
      bleu: "Royal Blue",
    },
  },
  es: {
    catsTab: "Gatos",
    catsTitle: "Medallas para gatos",
    catsText: "Colección especial para gatos • 25 mm • liviana y brillante.",
    size: "25 mm",
    priceSuffix: "CAD",
    select: "Elegir esta medalla",
    catNames: {
      turquoise: "Turquesa Premium",
      rouge: "Rojo Luxe",
      violet: "Morado Elegante",
      violetKey: "Morado con llavero",
      orange: "Naranja Energía",
      bleu: "Azul Royal",
    },
  },
};

const catalogItems = [
  { model: "hueso", color: "amarillo", file: "/img/catalogo/webp/placa-hueso-dorada-catalogo.webp", name: { fr: "Or", en: "Gold", es: "Dorado" } },
  { model: "hueso", color: "azul", file: "/img/catalogo/webp/placa-hueso-azul-catalogo.webp", name: { fr: "Bleu", en: "Blue", es: "Azul" } },
  { model: "hueso", color: "negro", file: "/img/catalogo/webp/placa-hueso-negro-catalogo.webp", name: { fr: "Noir", en: "Black", es: "Negro" } },
  { model: "hueso", color: "plata", file: "/img/catalogo/webp/placa-hueso-plata-catalogo.webp", name: { fr: "Argent", en: "Silver", es: "Plata" } },
  { model: "hueso", color: "rojo", file: "/img/catalogo/webp/placa-hueso-rojo-catalogo.webp", name: { fr: "Rouge", en: "Red", es: "Rojo" } },
  { model: "hueso", color: "rosado", file: "/img/catalogo/webp/placa-hueso-rosado-catalogo.webp", name: { fr: "Rose", en: "Pink", es: "Rosado" } },
  { model: "hueso", color: "rosado-palido", file: "/img/catalogo/webp/placa-hueso-rosa-claro-catalogo.webp", name: { fr: "Rose clair", en: "Blush", es: "Rosa claro" } },
  { model: "hueso", color: "verde", file: "/img/catalogo/webp/placa-hueso-verde-catalogo.webp", name: { fr: "Vert", en: "Green", es: "Verde" } },

  { model: "patas", color: "amarillo", file: "/img/catalogo/webp/placa-pata-dorada-catalogo.webp", name: { fr: "Or", en: "Gold", es: "Dorado" } },
  { model: "patas", color: "azul", file: "/img/catalogo/webp/placa-pata-azul-catalogo.webp", name: { fr: "Bleu", en: "Blue", es: "Azul" } },
  { model: "patas", color: "negro", file: "/img/catalogo/webp/placa-pata-negro-catalogo.webp", name: { fr: "Noir", en: "Black", es: "Negro" } },
  { model: "patas", color: "plata", file: "/img/catalogo/webp/placa-pata-plata-catalogo.webp", name: { fr: "Argent", en: "Silver", es: "Plata" } },
  { model: "patas", color: "rojo", file: "/img/catalogo/webp/placa-pata-rojo-catalogo.webp", name: { fr: "Rouge", en: "Red", es: "Rojo" } },
  { model: "patas", color: "rosado", file: "/img/catalogo/webp/placa-pata-rosado-catalogo.webp", name: { fr: "Rose", en: "Pink", es: "Rosado" } },
  { model: "patas", color: "rosado-palido", file: "/img/catalogo/webp/placa-pata-rosa-claro-catalogo.webp", name: { fr: "Rose clair", en: "Blush", es: "Rosa claro" } },
  { model: "patas", color: "verde", file: "/img/catalogo/webp/placa-pata-verde-catalogo.webp", name: { fr: "Vert", en: "Green", es: "Verde" } },

  { model: "redonda", color: "plata", file: "/img/catalogo/redondas/redonda-plata.webp", name: { fr: "Argent", en: "Silver", es: "Plata" } },
  { model: "redonda", color: "oro", file: "/img/catalogo/redondas/redonda-oro.webp", name: { fr: "Or", en: "Gold", es: "Oro" } },

  { model: "gatos", color: "turquoise", file: "/img/catalogo/gatos-25mm/gato_turquesa_25mm.webp", nameKey: "turquoise" },
  { model: "gatos", color: "rouge", file: "/img/catalogo/gatos-25mm/gato_rojo_llavero_25mm.webp", nameKey: "rouge" },
  { model: "gatos", color: "violet", file: "/img/catalogo/gatos-25mm/gato_morado_25mm.webp", nameKey: "violet" },
  { model: "gatos", color: "violet-key", file: "/img/catalogo/gatos-25mm/gato_morado_llavero_25mm.webp", nameKey: "violetKey" },
  { model: "gatos", color: "orange", file: "/img/catalogo/gatos-25mm/gato_naranja_25mm.webp", nameKey: "orange" },
  { model: "gatos", color: "bleu", file: "/img/catalogo/gatos-25mm/gato_azul_25mm.webp", nameKey: "bleu" },
];

export default function Catalogo({ t, lang, setScreen, setModel, setColor, track }) {
  const [category, setCategory] = useState("hueso");
  const [zoomedImage, setZoomedImage] = useState(null);
  const L = labels[lang] || labels.fr;

  const items = useMemo(
    () => catalogItems.filter((item) => item.model === category),
    [category]
  );

  const selectItem = (item) => {
    if (item.model === "gatos") {
      setModel("gatos");
      const catColorMap = {
        turquoise: "gato_turquesa",
        rouge: "gato_rojo",
        violet: "gato_morado",
        "violet-key": "gato_morado_llavero",
        orange: "gato_naranja",
        bleu: "gato_azul",
      };
      setColor(catColorMap[item.color] || "gato_turquesa");
      track?.("catalog_select_cat_25mm", { color: item.color, price: CAT_PRICE });
      setScreen("create");
      return;
    }

    setModel(item.model);
    setColor(item.color);
    track?.("catalog_select", { model: item.model, color: item.color });
    setScreen("create");
  };

  const labelForModel = (model) => {
    if (model === "hueso") return t.catalog_bone;
    if (model === "patas") return t.catalog_paw;
    if (model === "gatos") return L.catsTitle;
    return t.catalog_round || t.model_round || "Redonda acero";
  };

  const getName = (item) => {
    if (item.model === "gatos") return L.catNames[item.nameKey];
    return item.name?.[lang] || item.name?.fr || "";
  };

  return (
    <section className="page-card catalog-page">
      <div className="catalog-head">
        <span className="pill">{t.free_shipping_msg}</span>
        <h2>{category === "gatos" ? L.catsTitle : t.catalog_title}</h2>
        <p>{category === "gatos" ? L.catsText : t.catalog_text}</p>

        <div className="catalog-tabs" role="tablist" aria-label="Catalogue categories">
          <button type="button" className={category === "hueso" ? "active" : ""} onClick={() => { setCategory("hueso"); track?.("catalog_category", { category: "hueso" }); }}>
            🦴 {t.catalog_bone}
          </button>
          <button type="button" className={category === "patas" ? "active" : ""} onClick={() => { setCategory("patas"); track?.("catalog_category", { category: "patas" }); }}>
            🐾 {t.catalog_paw}
          </button>
          <button type="button" className={category === "redonda" ? "active" : ""} onClick={() => { setCategory("redonda"); track?.("catalog_category", { category: "redonda" }); }}>
            ⚪ {t.catalog_round || t.model_round || "Redonda acero"}
          </button>
          <button type="button" className={category === "gatos" ? "active" : ""} onClick={() => { setCategory("gatos"); track?.("catalog_category", { category: "gatos_25mm" }); }}>
            🐱 {L.catsTab}
          </button>
        </div>
      </div>

      <div className={category === "redonda" ? "catalog-grid catalog-grid-round" : "catalog-grid"}>
        {items.map((item) => {
          const modelLabel = labelForModel(item.model);
          const colorObj = COLORS.find(c => c.name === item.color);
          const price = item.model === "redonda" ? ROUND_PRICE : item.model === "gatos" ? CAT_PRICE : PRICE;

          return (
            <article key={`${item.model}-${item.color}`} className="catalog-card">
              <div className="catalog-image-wrap" onClick={() => setZoomedImage(item.file)}>
                <img src={item.file} alt={`${modelLabel} ${getName(item)}`} loading="lazy" />
              </div>

              <div className="catalog-card-info">
                <div>
                  <strong>{modelLabel}</strong>
                  <span>{getName(item)}</span>
                </div>
                <div className="catalog-price">${price.toFixed(2)}</div>
              </div>

              {item.model === "redonda" && (
                <p className="catalog-material-line">{t.spec_material} • {t.spec_size} • {t.round_shipping_label}</p>
              )}

              {item.model === "gatos" && (
                <p className="catalog-material-line">{L.size} • ${CAT_PRICE.toFixed(2)} {L.priceSuffix} • {t.round_shipping_label || t.free_shipping}</p>
              )}

              <button className="gold-btn catalog-btn" type="button" onClick={() => selectItem(item)}>
                {item.model === "gatos" ? L.select : t.catalog_select}
              </button>

              <span className="color-dot" style={{ backgroundColor: colorObj?.hex || "#D4AF37" }} aria-hidden="true" />
            </article>
          );
        })}

        {/* 3er recuadro: inspiración — solo en Ronde Acier */}
        {category === "redonda" && (
          <article
            className="catalog-card catalog-card-inspo"
            onClick={() => setZoomedImage("/img/redondas/disenos-redondas.png")}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === "Enter" && setZoomedImage("/img/redondas/disenos-redondas.png")}
            style={{ cursor: "zoom-in" }}
          >
            <div className="catalog-image-wrap inspo-image-wrap">
              <img
                src="/img/redondas/disenos-redondas.png"
                alt={lang === "fr" ? "Exemples de gravures personnalisées" : lang === "es" ? "Ejemplos de grabados personalizados" : "Custom engraving examples"}
                loading="lazy"
              />
              <span className="inspo-badge">
                {lang === "fr" ? "Inspiration" : lang === "es" ? "Inspiración" : "Inspiration"}
              </span>
            </div>
            <div className="catalog-card-info">
              <div>
                <strong>
                  {lang === "fr" ? "Galerie de designs" : lang === "es" ? "Galería de diseños" : "Design Gallery"}
                </strong>
                <span>
                  {lang === "fr" ? "Cliquez pour agrandir" : lang === "es" ? "Haz clic para ampliar" : "Click to enlarge"}
                </span>
              </div>
              <div className="inspo-zoom-icon">🔍</div>
            </div>
            <button
              className="gold-btn catalog-btn"
              type="button"
              onClick={(e) => { e.stopPropagation(); setZoomedImage("/img/redondas/disenos-redondas.png"); }}
            >
              {lang === "fr" ? "VOIR LES DESIGNS" : lang === "es" ? "VER DISEÑOS" : "VIEW DESIGNS"}
            </button>
          </article>
        )}
      </div>



      {zoomedImage && createPortal(
        <Lightbox src={zoomedImage} onClose={() => setZoomedImage(null)} />,
        document.body
      )}
    </section>
  );
}

function Lightbox({ src, onClose }) {
  // Lock body scroll while open and close on Escape
  useEffect(() => {
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = prevOverflow;
      window.removeEventListener("keydown", onKey);
    };
  }, [onClose]);

  return (
    <div className="lightbox-overlay" onClick={onClose} role="dialog" aria-modal="true">
      <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
        <button className="lightbox-close" onClick={onClose} aria-label="Fermer">✕</button>
        <img src={src} alt="Zoom" />
      </div>
    </div>
  );
}